<script>
	const _ = require('underscore');

	module.exports = {
		components: {
			'info-icon': require('components/svg/info-icon.vue').default,
			message: require('components/message.vue').default
		},
		props: [
			'assign-to',
			'new-assignment-form',
			'product',
			'loading-classes',
			'classes-by-code',
			'start-date',
			'deadline',
			'classes',
			'studentChoices',
			'current-class-has-ell',
			'assignment',
			'groups',
			'gcAddon'
		],
		data() {
			return {
				ellTip:
					'For Article-A-Day only, this provides audio and additional features for students. Teachers decide which students have access to these extra supports. <a href="/teacher-guide/differentiation-tools.html#ell">Learn how to turn it on and what it provides.</a>',
				dueDateTip: 'Students will be able to continue working on Article and Paired Text assignments after the due date passes.',
				endDateTip: 'Students will not be able to continue working on Article-A-Day assignments after the end date passes.',
				studentChoiceTip:
					'This controls how many articles a student has access to when they open their Article-A-Day set. If you select "Students read the same articles" only one article in the set will be available at a time. The next article will become available when they’ve completed the first one.',
				vocabTooltip: 'Assign activities designed for students to more deeply explore the vocabulary highlighted in the passage.',
				newAssignmentFormInternal: null
			};
		},
		computed: {
			deadlineTooltip: function () {
				if (this.product.productType === 'AAD') {
					return this.endDateTip;
				}
				return this.dueDateTip;
			},
			passageLabel() {
				let product = this.product;
				let label = 'Reading Passage';

				if (product.productType === 'P' && product.hasVideo) {
					label = 'Passage & Video';
				} else if (product.productType === 'P' || product.productType === 'AAD') {
					label += 's';
				}

				return label;
			},
			assignmentMaxDate() {
				let date = null;
				return date;
			},
			currentClass() {
				return this.classesByCode[this.newAssignmentForm.classCode];
			},
			noStudents() {
				const currentClass = this.currentClass;
				return !currentClass || currentClass.studentCount === 0;
			}
		},
		methods: {
			// Should only happen in assign modal on
			// user change of start date
			onStartDateChange: function (value, oldValue) {
				this.$emit('update:deadline', this.deadline + (value - oldValue));
				this.$emit('update:startDate', value);
			}
		},
		watch: {
			newAssignmentForm: {
				handler(value) {
					this.newAssignmentFormInternal = value;
				},
				immediate: true
			},
			newAssignmentFormInternal(value) {
				if (!_.isEqual(value, this.newAssignmentForm)) {
					this.$emit('update:newAssignmentForm', value);
				}
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'mixins/flexbox';

	.assign-to.form-row {
		margin-bottom: 0em;
	}

	.form-row.dates {
		margin-top: 1rem;

		.date {
			padding-left: 0rem;

			input[type='text'] {
				width: 100%;
			}
		}
	}

	.assign-ell-check {
		&.disabled {
			input,
			span {
				opacity: 0.4;
			}

			.small-icon {
				opacity: 1;
			}
		}

		.form-row {
			margin-bottom: 1.5em;
		}
	}

	.google-classroom-publish {
		margin-top: 1rem;

		.small-icon {
			opacity: 1;
		}
	}

	.assignment-modal-form-left {
		.full-or-express {
			label {
				margin-left: 1.9rem;
			}
		}

		.tooltipped-label-wrapper {
			label {
				display: inline-block;
			}
		}
	}
</style>
<template>
	<div>
		<div class="assignment-modal-form-left">
			<div class="form-row">
				<template v-if="typeof product.hasAudio === 'function' && product.hasAudio()">
					<div class="">
						<auto-form-row
							part-of-row
							:data.sync="newAssignmentFormInternal.assignAudio"
							:form-property="'assignAudio'"
							:label="product.productType === 'P' && product.hasVideo ? 'Passage Audio' : 'Audio'"
							type="checkbox">
						</auto-form-row>
					</div>
				</template>
				<template v-if="product.supplemental_texts">
					<div
						class=""
						v-if="product.supplemental_texts.support">
						<auto-form-row
							part-of-row
							:data.sync="newAssignmentFormInternal.supportArticles"
							:form-property="'supportArticles'"
							label="Boost Articles"
							type="checkbox">
						</auto-form-row>
					</div>
					<div
						class=""
						v-if="product.supplemental_texts.challenge">
						<auto-form-row
							part-of-row
							:data.sync="newAssignmentFormInternal.challengeArticles"
							:form-property="'challengeArticles'"
							label="Challenge Articles"
							type="checkbox">
						</auto-form-row>
					</div>
				</template>
				<template v-if="product.productType === 'AAD'">
					<auto-form-row
						part-of-row
						:data.sync="newAssignmentFormInternal.assignBookOfKnowledge"
						:form-property="'assignBookOfKnowledge'"
						:label="'Book of Knowledge'"
						type="checkbox">
					</auto-form-row>
				</template>
				<label v-if="product.productType === 'AAD' && product.dteGroups">
					<input
						type="checkbox"
						v-model="newAssignmentFormInternal.decodables"
						name="decodables" />
					<span>Decodables</span>
				</label>
				<template v-if="product.productType === 'AAD' && product.word_detective">
					<auto-form-row
						part-of-row
						:data.sync="newAssignmentFormInternal.wordDetective"
						:form-property="'wordDetective'"
						:label="'Word Detective'"
						type="checkbox">
					</auto-form-row>
				</template>
				<template v-if="product.productType === 'AAD' && product.meaning_mapper">
					<auto-form-row
						part-of-row
						:data.sync="newAssignmentFormInternal.meaningMapper"
						:form-property="'meaningMapper'"
						:label="'Meaning Mapper'"
						type="checkbox">
					</auto-form-row>
				</template>
				<template v-if="product.sr">
					<div
						class=""
						v-for="(stepread, srIndex) in newAssignmentFormInternal.stepReads"
						:key="stepread.order">
						<auto-form-row
							part-of-row
							:data.sync="stepread.selected"
							:form-property="'assignStepRead-' + srIndex"
							:label="'StepRead' + (srIndex + 1) + ' (SR' + (srIndex + 1) + ')'"
							type="checkbox">
						</auto-form-row>
					</div>
				</template>
				<template v-if="product.ebook">
					<div class="">
						<auto-form-row
							part-of-row
							:data.sync="newAssignmentFormInternal.assignEBook"
							:form-property="'assignEBook'"
							:label="'eBook'"
							type="checkbox">
						</auto-form-row>
					</div>
				</template>
				<template v-if="product.productType === 'A' && product.hasVideo">
					<auto-form-row
						part-of-row
						:data.sync="newAssignmentFormInternal.video"
						:form-property="'video'"
						:label="'Video'"
						type="checkbox">
					</auto-form-row>
				</template>
				<template v-if="newAssignmentFormInternal.hasVocabularyActivities">
					<div class="tooltipped-label-wrapper">
						<label>
							<input
								type="checkbox"
								v-model="newAssignmentFormInternal.assignVocabActivities" />
							Vocabulary Activity
						</label>
						<button
							class="button -link"
							type="button"
							v-tooltip="vocabTooltip">
							<info-icon></info-icon>
						</button>
					</div>
				</template>
				<template v-for="(qset, qsetIndex) in newAssignmentFormInternal.questionSets">
					<auto-form-row
						part-of-row
						:data.sync="qset.selected"
						:form-property="'questionSets-' + qsetIndex"
						:label="qset.title"
						type="checkbox">
					</auto-form-row>
					<div
						v-if="qset.fullOrExpress"
						class="label full-or-express">
						<label>
							<input
								type="radio"
								value="f"
								v-model="qset.fullOrExpress" />
							Full
						</label>
						<label>
							<input
								type="radio"
								value="x"
								v-model="qset.fullOrExpress" />
							Express
						</label>
					</div>
				</template>
			</div>
			<div
				v-if="product.productType === 'AAD'"
				class="form-row-input margin-bottom-medium">
				<div class="tooltipped-label-wrapper">
					<label>Student Choice for Articles</label>
					<button
						class="button -link"
						type="button"
						v-tooltip="studentChoiceTip">
						<info-icon></info-icon>
					</button>
				</div>
				<div class="input-select">
					<select v-model="newAssignmentFormInternal.studentChoice">
						<option
							v-for="choice in studentChoices"
							:key="choice.value"
							:value="choice.value"
							:selected="newAssignmentFormInternal.studentChoice === choice.value"
							:disabled="choice.disabled">
							{{ choice.text }}
						</option>
					</select>
				</div>
			</div>
			<auto-form-row
				class="class-select"
				:data.sync="newAssignmentFormInternal.classCode"
				:options="classes"
				form-property="classCode"
				label="Class"
				:options-loading="loadingClasses"
				type="select">
			</auto-form-row>
			<div
				class="assign-to form-row"
				v-show="newAssignmentFormInternal.classCode !== 'new'">
				<div class="label">Assign to:</div>
				<message
					class="gca-student-assignment-message"
					v-if="gcAddon && assignTo !== 'c'">
					Please be sure to match your student selections in Google Classroom.
				</message>
				<div class="toggle-buttons">
					<label
						class="toggle-button button -small"
						:class="{
							active: assignTo === 'c',
							disabled: noStudents
						}"
						data-text="
						Whole Class">
						<input
							:disabled="noStudents"
							type="radio"
							name="assign"
							value="c"
							v-model="assignTo"
							@change="$emit('update:assignTo', $event.target.value)" />
						Whole Class
					</label>
					<label
						class="toggle-button button -small"
						:class="{
							active: assignTo === 's',
							disabled: noStudents
						}"
						data-text="Specific Students">
						<input
							:disabled="noStudents"
							type="radio"
							name="assign"
							value="s"
							v-model="assignTo"
							@change="$emit('update:assignTo', $event.target.value)" />
						Specific Students
					</label>
					<label
						class="toggle-button button -small"
						:class="{
							active: assignTo === 'g',
							disabled: noStudents || groups.length === 0
						}"
						data-text="Group">
						<input
							:disabled="noStudents || groups.length === 0"
							type="radio"
							name="assign"
							value="g"
							v-model="assignTo"
							@change="$emit('update:assignTo', $event.target.value)" />
						Group
					</label>
				</div>
				<div
					class="label -centered"
					v-if="noStudents">
					No Students in Class
				</div>
				<div
					v-if="assignTo === 'g'"
					class="form-row-input">
					<div class="input-select">
						<select v-model="newAssignmentFormInternal.selectedGroup">
							<option
								v-for="group in groups"
								:key="group.value"
								:value="group.value"
								:selected="newAssignmentFormInternal.selectedGroup === group.value"
								:disabled="group.disabled">
								{{ group.text }}
							</option>
						</select>
					</div>
				</div>
			</div>
		</div>
		<div
			v-if="product.productType === 'AAD'"
			:class="{
				'assign-ell-check': true,
				disabled: !currentClassHasEll
			}">
			<label>
				<input
					class="input-checkbox"
					type="checkbox"
					:disabled="!currentClassHasEll"
					v-model="newAssignmentFormInternal.ell" />
				<span> Turn on ELL and Extra Support features </span>
				<button
					class="button -link"
					type="button"
					v-tooltip="ellTip">
					<info-icon aria-label="ELL"></info-icon>
				</button>
			</label>
		</div>
		<div
			v-if="currentClass && currentClass.gcid && !gcAddon"
			class="google-classroom-publish"
			:class="{
				disabled: !!assignment
			}">
			<label>
				<input
					class="input-checkbox"
					type="checkbox"
					:disabled="!!assignment"
					v-model="newAssignmentFormInternal.publishToGoogleClassroom" />
				<span v-if="!assignment"> Publish to Google Classroom </span>
				<span
					v-if="assignment"
					class="label">
					Publish to Google Classroom
					<button
						class="button -link"
						type="button"
						v-tooltip="'This can only be set when creating an assignment.'">
						<info-icon></info-icon>
					</button>
				</span>
			</label>
		</div>
		<div class="form-row dates row">
			<div class="start-date date small-12 medium-6 columns">
				<div class="label">Assignment Start Date</div>
				<div class="form-row-input">
					<date-picker
						:date.sync="startDate"
						:max-date="assignmentMaxDate"
						:on-date-select="onStartDateChange">
					</date-picker>
				</div>
			</div>
			<template v-if="deadline">
				<div class="deadline-date date small-12 medium-6 columns">
					<div class="label">
						{{ product.productType === 'AAD' ? 'End Date' : 'Due Date' }}
						<button
							class="button -link"
							type="button"
							v-tooltip="deadlineTooltip">
							<info-icon></info-icon>
						</button>
					</div>
					<div class="form-row-input">
						<date-picker
							:date.sync="deadline"
							:min-date="startDate"
							:on-date-select="date => $emit('update:deadline', date)">
						</date-picker>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>
